// React imports
import React, { MouseEventHandler } from 'react';
import classNames from 'classnames';
import './styles/index.scss';
// Props type for menu button
type MenuItemProps = {
  onSelect: MouseEventHandler<HTMLButtonElement>;
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
};

/**
 * Menu Button component for display multiple options
 * @param props
 */
const MenuItem = (props: MenuItemProps) => {
  const classnames = classNames(
    'chakra-select-button chakra-item-button',
    props.className
  );

  return (
    <button
      type="button"
      role="menuitem"
      onClick={props.onSelect}
      disabled={props.disabled}
      className={classnames}>
      {props.children}
    </button>
  );
};

export { MenuItemProps, MenuItem };
